import { z } from "zod";
import { BaseModelFields } from "./base-model";

export interface Pickup extends BaseModelFields {
  orderId: string; // Long -> string for BigInt handling
  courierName: string;
  pickupStatus: string;
  pickupTime: string; // LocalDateTime -> ISO string
}

// Request/Response DTOs (single source of truth for API contracts)
export interface PickupCreateRequest {
  orderId: string;
  courierName: string;
  pickupStatus: string;
  pickupTime: string;
  isActive?: boolean;
}

export interface PickupUpdateRequest {
  orderId?: string;
  courierName?: string;
  pickupStatus?: string;
  pickupTime?: string;
  isActive?: boolean;
}

// Pickup form schema for create operations
export const pickupCreateSchema = z.object({
  orderId: z.string().min(1, "Order ID is required"),
  courierName: z.string().min(1, "Courier name is required"),
  pickupStatus: z.string().min(1, "Pickup status is required"),
  pickupTime: z.string().min(1, "Pickup time is required"),
  isActive: z.boolean().optional(),
});

// Pickup form schema for update operations
export const pickupUpdateSchema = z.object({
  orderId: z.string().min(1, "Order ID is required").optional(),
  courierName: z.string().min(1, "Courier name is required").optional(),
  pickupStatus: z.string().min(1, "Pickup status is required").optional(),
  pickupTime: z.string().min(1, "Pickup time is required").optional(),
  isActive: z.boolean().optional(),
});

// Pickup form values types
export type PickupCreateFormValues = z.infer<typeof pickupCreateSchema>;
export type PickupUpdateFormValues = z.infer<typeof pickupUpdateSchema>;
